export default {
  noDescription: 'No description',
  start: 'Start',
  plannedStart: 'Planned start of batch'
};
